import getReducer from '../getReducer'
import assign from 'object-assign'

import {RECRUITMENT_MY_LIST_REQUEST, RECRUITMENT_MY_LIST_SUCCESS, RECRUITMENT_MY_LIST_FAILURE} from '../../action/recruitment/myList'
import {RECRUITMENT_LIST_REQUEST, RECRUITMENT_LIST_SUCCESS, RECRUITMENT_LIST_FAILURE} from '../../action/recruitment/list'
import {NEED_PERSON_LIST_REQUEST, NEED_PERSON_LIST_SUCCESS, NEED_PERSON_LIST_FAILURE} from '../../action/recruitment/needPersonList'
import {NEED_PERSON_DETAIL_REQUEST, NEED_PERSON_DETAIL_SUCCESS, NEED_PERSON_DETAIL_FAILURE} from '../../action/recruitment/needPersonDetail'
import {UPDATE_NEED_PERSON_REQUEST, UPDATE_NEED_PERSON_SUCCESS, UPDATE_NEED_PERSON_FAILURE} from '../../action/recruitment/updateNeedPerson'
import {CREATE_NEED_PERSON_REQUEST, CREATE_NEED_PERSON_SUCCESS, CREATE_NEED_PERSON_FAILURE} from '../../action/recruitment/createNeedPerson'
import {RECRUITMENT_UPDATE_STATUS_REQUEST, RECRUITMENT_UPDATE_STATUS_SUCCESS, RECRUITMENT_UPDATE_STATUS_FAILURE} from '../../action/recruitment/updateRecruitmentStatus'
import {START_JOB_REQUEST, START_JOB_SUCCESS, START_JOB_FAILURE} from '../../action/recruitment/startJob'
import {REFUSE_JOB_REQUEST, REFUSE_JOB_SUCCESS, REFUSE_JOB_FAILURE} from '../../action/recruitment/refuseJob'
import {PERSON_LIST_REQUEST, PERSON_LIST_SUCCESS, PERSON_LIST_FAILURE} from '../../action/recruitment/personList'

import {ENTRYLIST_REQUEST, ENTRYLIST_SUCCESS, ENTRYLIST_FAILURE} from '../../action/recruitment/entryList'
import {LONG_DATE_REQUEST, LONG_DATE_SUCCESS, LONG_DATE_FAILURE} from '../../action/recruitment/longDate'
import {EXPORT_USER_REQUEST, EXPORT_USER_SUCCESS, EXPORT_USER_FAILURE} from '../../action/recruitment/exportUser'

// 角色
import { ROLE_LIST_REQUEST, ROLE_LIST_SUCCESS, ROLE_LIST_FAILURE } from '../../action/role/list'
// 公司
import { COMPANY_GET_ALL_REQUEST, COMPANY_GET_ALL_SUCCESS, COMPANY_GET_ALL_FAILURE } from '../../action/company/getall'
import { DEPARTMENT_TREE_REQUEST, DEPARTMENT_TREE_SUCCESS, DEPARTMENT_TREE_FAILURE } from '../../action/department/tree'

import {USER_GET_ALL_REQUEST, USER_GET_ALL_SUCCESS, USER_GET_ALL_FAILURE} from '../../action/user/getall'
import {POSITION_GET_ALL_REQUEST, POSITION_GET_ALL_SUCCESS, POSITION_GET_ALL_FAILURE} from '../../action/position/getall'
import {TRY_LIST_REQUEST, TRY_LIST_SUCCESS, TRY_LIST_FAILURE} from '../../action/recruitment/getTryList'

import {UPDATE_MONTH_EVALUATION_REQUEST, UPDATE_MONTH_EVALUATION_SUCCESS, UPDATE_MONTH_EVALUATION_FAILURE} from '../../action/recruitment/updateMonthEvaluation'
import {UPDATE_MEMO_REQUEST, UPDATE_MEMO_SUCCESS, UPDATE_MEMO_FAILURE} from '../../action/recruitment/updateMemo'

import {RECRUITMENT_COMPLETE_REQUEST, RECRUITMENT_COMPLETE_SUCCESS, RECRUITMENT_COMPLETE_FAILURE} from '../../action/recruitment/recruitmentComplete'
import {RECRUITMENT_CLOSE_REQUEST, RECRUITMENT_CLOSE_SUCCESS, RECRUITMENT_CLOSE_FAILURE} from '../../action/recruitment/recruitmentClose'

// HR
import {USER_GET_BY_ROLENAME_REQUEST, USER_GET_BY_ROLENAME_SUCCESS, USER_GET_BY_ROLENAME_FAILURE} from '../../action/user/getUserByRoleName'
function recruitment(state = {
	showLoading: false,
	allUsers: [],
	recruitmentList: {
		data: [],
		page: 1,
		total: 0,
		size: 10
  },
  recruitmentMyList: {
		data: [],
		page: 1,
		total: 0,
		size: 10
	},
  personList: {
		data: [],
		page: 1,
		pageSize: 10,
		total: 0
	},
	// 待入职人员列表
	entryList: {
		data: [],
		page: 1,
		size: 10,
		total: 0
	},
	tryList: {
		data: [],
		page: 1,
		size: 10,
		total: 0
	},
	// 所有部门
	departmentTree: [],
  // 所有职位
	positions: [],
	// 需求人员列表
	needPersonList: [],
	// 需求人员详情
	needPersonDetail: {},
	// 公司
	companies: [],
	// 角色
	roleList: [],
	hrList: [],
}, action) {
	switch (action.type) {
		// 发起入职
		case START_JOB_REQUEST:
			return assign({}, state, {showLoading: true})
		case START_JOB_SUCCESS:
			return assign({}, state, {showLoading: false})
		case START_JOB_FAILURE:
			return assign({}, state, {showLoading: false})

		// 入职状态调整
		case REFUSE_JOB_REQUEST:
			return assign({}, state, {showLoading: true})
		case REFUSE_JOB_SUCCESS:
			return assign({}, state, {showLoading: false})
		case REFUSE_JOB_FAILURE:
			return assign({}, state, {showLoading: false})

		// 更新需求人员
		case UPDATE_NEED_PERSON_REQUEST:
			return assign({}, state, {showLoading: true})
		case UPDATE_NEED_PERSON_SUCCESS:
			return assign({}, state, {showLoading: false})
		case UPDATE_NEED_PERSON_FAILURE:
			return assign({}, state, {showLoading: false})

		// 更新岗位状态
		case RECRUITMENT_UPDATE_STATUS_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_UPDATE_STATUS_SUCCESS:
			return assign({}, state, {showLoading: false})
		case RECRUITMENT_UPDATE_STATUS_FAILURE:
			return assign({}, state, {showLoading: false})

		// 创建需求人员
		case CREATE_NEED_PERSON_REQUEST:
			return assign({}, state, {showLoading: true})
		case CREATE_NEED_PERSON_SUCCESS:
			return assign({}, state, {showLoading: false})
		case CREATE_NEED_PERSON_FAILURE:
			return assign({}, state, {showLoading: false})

		// 需求人员列表
		case NEED_PERSON_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEED_PERSON_LIST_SUCCESS:
			return assign({}, state, {
				needPersonList: action.response.result.data,
				showLoading: false
			})
		case NEED_PERSON_LIST_FAILURE:
			return assign({}, state, {showLoading: false})
		
			// 待入职人员
		case ENTRYLIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case ENTRYLIST_SUCCESS:
			return assign({}, state, {
				entryList: action.response.result,
				showLoading: false
			})
		case ENTRYLIST_FAILURE:
			return assign({}, state, {showLoading: false})
		
		// 人员列表
		case PERSON_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case PERSON_LIST_SUCCESS:
			return assign({}, state, {
				personList: action.response.result,
				showLoading: false
			})
		case PERSON_LIST_FAILURE:
			return assign({}, state, {showLoading: false})

		// 需求人员详情
		case NEED_PERSON_DETAIL_REQUEST:
			return assign({}, state, {showLoading: true})
		case NEED_PERSON_DETAIL_SUCCESS:
			return assign({}, state, {
				needPersonDetail: action.response.result,
				showLoading: false
			})
		case NEED_PERSON_DETAIL_FAILURE:
			return assign({}, state, {showLoading: false})
		
    // 招聘需求
		case RECRUITMENT_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_LIST_SUCCESS:
			return assign({}, state, {
				recruitmentList: action.response.result,
				showLoading: false
			})
		case RECRUITMENT_LIST_FAILURE:
      return assign({}, state, {showLoading: false})

    // 我的招聘需求
		case RECRUITMENT_MY_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_MY_LIST_SUCCESS:
			return assign({}, state, {
				recruitmentMyList: action.response.result,
				showLoading: false
			})
		case RECRUITMENT_MY_LIST_FAILURE:
			return assign({}, state, {showLoading: false})

		 // 获取所有员工
    case USER_GET_ALL_REQUEST:
     return assign({}, state, {showLoading: true})
    case USER_GET_ALL_SUCCESS:
     return assign({}, state, {
       allUsers: action.response.result.users,
       showLoading: false
     })
    case USER_GET_ALL_FAILURE:
     return assign({}, state, {showLoading: false})
		
		// 获取所有职位
    case POSITION_GET_ALL_REQUEST:
			return assign({}, state, {showLoading: true})
		case POSITION_GET_ALL_SUCCESS:
			return assign({}, state, {
				positions: action.response.result.positions,
        showLoading: false
			})
		case POSITION_GET_ALL_FAILURE:
			return assign({}, state, {showLoading: false})
    
    // 获取所有部门
    case DEPARTMENT_TREE_REQUEST:
			return assign({}, state, {showLoading: true})
		case DEPARTMENT_TREE_SUCCESS:
			return assign({}, state, {
				departmentTree: action.response.result.departmentTree,
        showLoading: false
			})
		case DEPARTMENT_TREE_FAILURE:
			return assign({}, state, {showLoading: false})
		
		// 延期入职
		case LONG_DATE_REQUEST:
			return assign({}, state, {showLoading: true})
		case LONG_DATE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case LONG_DATE_FAILURE:
			return assign({}, state, {showLoading: false})
		
		// 正式入职
		case EXPORT_USER_REQUEST:
			return assign({}, state, {showLoading: true})
		case EXPORT_USER_SUCCESS:
			return assign({}, state, {showLoading: false})
		case EXPORT_USER_FAILURE:
			return assign({}, state, {showLoading: false})
		
		// 公司列表
		case COMPANY_GET_ALL_REQUEST:
			return assign({}, state, {})
		case COMPANY_GET_ALL_SUCCESS:
			return assign({}, state, {
				companies: action.response.result.companies
			})
		case COMPANY_GET_ALL_FAILURE:
			return assign({}, state, {})
		
			//角色
		case ROLE_LIST_REQUEST:
			return assign({}, state, {})
		case ROLE_LIST_SUCCESS:
			return assign({}, state, {
				roleList: action.response.result.info,
			})
		case ROLE_LIST_FAILURE:
			return assign({}, state, {})

		// hr
		case USER_GET_BY_ROLENAME_REQUEST:
			return assign({}, state, {})
		case USER_GET_BY_ROLENAME_SUCCESS:
			return assign({}, state, {
				hrList: action.response.result,
			})
		case USER_GET_BY_ROLENAME_FAILURE:
			return assign({}, state, {})
		
		// 部门tree
		case DEPARTMENT_TREE_REQUEST:
			return assign({}, state, {});
		case DEPARTMENT_TREE_SUCCESS:
			return assign({}, state, {
				departmentTree: action.response.result.departmentTree
			});
		case DEPARTMENT_TREE_FAILURE:
			return assign({}, state, {});
		
			// 试用期管理列表
		case TRY_LIST_REQUEST:
			return assign({}, state, {showLoading: true})
		case TRY_LIST_SUCCESS:
			return assign({}, state, {
				tryList: action.response.result,
				showLoading: false
			})
		case TRY_LIST_FAILURE:
			return assign({}, state, {showLoading: false})
		
		// 更新月度评价
		case UPDATE_MONTH_EVALUATION_REQUEST:
			return assign({}, state, {showLoading: true})
		case UPDATE_MONTH_EVALUATION_SUCCESS:
			return assign({}, state, {showLoading: false})
		case UPDATE_MONTH_EVALUATION_FAILURE:
			return assign({}, state, {showLoading: false})
			
		// 更新备注
		case UPDATE_MEMO_REQUEST:
			return assign({}, state, {showLoading: true})
		case UPDATE_MEMO_SUCCESS:
			return assign({}, state, {showLoading: false})
		case UPDATE_MEMO_FAILURE:
			return assign({}, state, {showLoading: false})

		// 我的招聘/完成招聘
		case RECRUITMENT_COMPLETE_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_COMPLETE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case RECRUITMENT_COMPLETE_FAILURE:
			return assign({}, state, {showLoading: false})

		// 我的招聘/关闭招聘
		case RECRUITMENT_CLOSE_REQUEST:
			return assign({}, state, {showLoading: true})
		case RECRUITMENT_CLOSE_SUCCESS:
			return assign({}, state, {showLoading: false})
		case RECRUITMENT_CLOSE_FAILURE:
			return assign({}, state, {showLoading: false})

		default:
			return state
	}
}

export default getReducer(recruitment)


// WEBPACK FOOTER //
// ./src/reducer/recruitment/index.js